<template>
  <v-row v-if="!$vuetify.breakpoint.smAndDown" class="center-content pa-4 ma-0">
    <v-col class="pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
      <v-card flat>
        <!-- <v-card-title class="dark-header header-title">
          <BreadCrumb />
        </v-card-title>
        <v-divider></v-divider> -->
        <v-card-text class="pa-0">
          <v-row class="ma-0">
            <v-col cols="12" xs="12" sm="3" md="6" lg="3" xl="3" class="pa-4">
              <span class="filter-design">From date</span>
              <date-field
                v-model="fromDate"
                placeholder="Select from date"
                @change="onDateChange()"
                hide-details
                solo
              />
            </v-col>
            <v-col cols="12" xs="12" sm="3" md="6" lg="3" xl="3" class="pa-4">
              <span class="filter-design">To date</span>
              <date-field
                v-model="toDate"
                :min="fromDate"
                placeholder="Select to date"
                @change="onDateChange()"
                hide-details
                solo
              />
            </v-col>
            <v-col cols="12" xs="12" sm="3" md="6" lg="3" xl="3" class="pa-4">
              <span class="filter-design">Appointment status</span>
              <select-field
                v-model="status"
                :items="statusList"
                @change="onStatusChange()"
                hide-details
                solo
              />
            </v-col>
            <v-col
              cols="12"
              xs="12"
              sm="3"
              md="6"
              lg="3"
              xl="3"
              align-self="center"
              class="pt-7 px-0"
            >
              <v-btn
                :disabled="clearFilterDisable"
                text
                color="red"
                class="text-transform"
                large
                @click="clearAllFields"
                >Clear filters</v-btn
              >
            </v-col>
            <v-col class="pa-4" cols="12">
              <v-card outlined>
                <v-data-table
                  :headers="headers"
                  :items="bookings"
                  :loading="loading"
                  :footer-props="{
                    'items-per-page-options': [10, 20, 30, 50, 100]
                  }"
                  loading-text="Loading... Please wait"
                  class="table-footer-text dark-header"
                >
                  <template v-slot:item.doctorObj.firstName="{ item }">
                    <div class="table-body-text" v-if="item.doctorObj">
                      {{ item.doctorObj.firstName }}
                      {{ item.doctorObj.lastName }}
                    </div>
                  </template>
                  <template v-slot:item.bookingDate="{ item }">
                    <div class="table-body-text-light">
                      {{ converIsoToDate(item.bookingStartDate) }}
                    </div>
                  </template>
                  <template v-slot:item.bookingStartDate="{ item }">
                    <div class="table-body-text-light">
                      {{ converIsoToTime(item.bookingStartDate) }} to
                      {{ converIsoToTime(item.bookingEndDate) }}
                    </div>
                  </template>
                  <!-- <template v-slot:item.bookingEndDate="{ item }">
                    <div class="table-body-text-light">
                      {{ converIsoToTime(item.bookingEndDate) }}
                    </div>
                  </template> -->
                  <template v-slot:item.bookingTypeObj.fees="{ item }">
                    <div class="table-body-text">
                      {{ "£ " + parseInt(item.bookingTypeObj.fees, 0) / 100 }}
                    </div>
                  </template>
                  <template v-slot:item.status="{ item }">
                    <v-alert
                      :color="
                        (statusObj = getStatusColor(item.status))
                          ? statusObj.color
                          : '#EF4444'
                      "
                      class="status-alert px-3 py-1"
                      dense
                      text
                      >{{ bookingStatus(item) }}</v-alert
                    >
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-tooltip
                      bottom
                      :color="$vuetify.theme.themes.light.tooltipColor"
                    >
                      <template v-slot:activator="{ on: tooltip, attrs }">
                        <img
                          v-if="
                            item.status !== APPOINTMENT_COMPLETED &&
                              item.status !== REJECTED_BY_PATIENT
                          "
                          v-bind="attrs"
                          v-on="{ ...tooltip }"
                          @click="editBooking(item)"
                          src="@/assets/icons/booking_Edit.svg"
                          width="22px"
                        />
                      </template>
                      <span>Edit</span>
                    </v-tooltip>
                    <reject-booking
                      v-if="
                        [
                          APPOINTMENT_PENDING_FOR_APPROVAL,
                          APPOINTMENT_APPROVED,
                          APPOINTMENT_RESCHEDULED,
                          RESCHEDULED_APPOINTMENT_APPROVED
                        ].indexOf(item.status) !== -1
                      "
                      :label="'Delete Booking'"
                      :bookingId="item._id"
                      @refresh="refresh"
                    ></reject-booking>
                    <v-btn
                      v-if="item.status === APPOINTMENT_COMPLETED"
                      outlined
                      color="#096DD8"
                      class="schedule-text"
                      small
                      @click="editBooking(item)"
                    >
                      Schedule again
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card>
              <!-- <div class="text-center pt-2">
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
              </div> -->
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
  <div v-else>
    <v-row v-if="!applyFilters">
      <v-row class="px-6 pt-2">
        <v-col cols="12">
          <v-text-field
            v-model="searchVal"
            v-debounce:1s="searchBooking"
            solo
            append-icon="mdi-magnify"
            label="Search booking"
            hide-details
            clearable
            class="search-message-input"
            :debounce-events="['click', 'keydown']"
            @click:clear="
              searchVal = '';
              searchBooking();
            "
          />
        </v-col>
        <v-col cols="6">
          <v-select
            v-model="sortBy"
            :items="sortOptions"
            item-value="value"
            item-text="text"
            dense
            outlined
            placeholder="Sort by"
            hide-details
          />
        </v-col>
        <v-col cols="6" class="text-right pa-6">
          <span class="filter-text px-1" @click="applyFilters = true"
            >Filter</span
          >
          <img src="@/assets/icons/filter.svg" />
        </v-col>
        <v-row v-if="!clearFilterDisable" class="border-bottom px-2">
          <v-col cols="6">
            <v-btn
              v-if="fromDate || toDate"
              rounded
              outlined
              class="text-capitalize"
              color="#A4B0BF"
              disabled
            >
              <span class="date-text"
                >From {{ converIsoToDate(fromDate) }} -
                {{ converIsoToDate(toDate) }}</span
              >
            </v-btn>
          </v-col>
          <v-col cols="6" class="text-right">
            <v-btn
              text
              color="#EF4444"
              class="text-capitalize date-text"
              @click="clearAllFields"
            >
              Clear filters
            </v-btn>
          </v-col>
        </v-row>
      </v-row>
      <v-col
        v-for="item in bookingsMobileView"
        :key="item._id"
        cols="12"
        class="py-0"
      >
        <v-card outlined>
          <v-list class="pa-0">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="card-title">
                  {{ item.doctorObj.firstName }} {{ item.doctorObj.lastName }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action
                v-if="
                  (item.status !== APPOINTMENT_COMPLETED &&
                    item.status !== REJECTED_BY_PATIENT) ||
                    [
                      APPOINTMENT_PENDING_FOR_APPROVAL,
                      APPOINTMENT_APPROVED,
                      APPOINTMENT_RESCHEDULED,
                      RESCHEDULED_APPOINTMENT_APPROVED
                    ].indexOf(item.status) !== -1 ||
                    item.status === APPOINTMENT_COMPLETED
                "
              >
                <v-menu bottom left attach>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      @click="editBooking(item)"
                      v-if="
                        item.status !== APPOINTMENT_COMPLETED &&
                          item.status !== REJECTED_BY_PATIENT
                      "
                    >
                      Edit
                    </v-list-item>
                    <reject-booking
                      v-if="
                        [
                          APPOINTMENT_PENDING_FOR_APPROVAL,
                          APPOINTMENT_APPROVED,
                          APPOINTMENT_RESCHEDULED,
                          RESCHEDULED_APPOINTMENT_APPROVED
                        ].indexOf(item.status) !== -1
                      "
                      :label="'Delete Booking'"
                      :bookingId="item._id"
                      @refresh="refresh"
                    ></reject-booking>
                    <v-list-item
                      v-if="item.status === APPOINTMENT_COMPLETED"
                      @click="editBooking(item)"
                    >
                      Schedule again
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-list-item-action>
            </v-list-item>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-subtitle>
                  <v-alert
                    :color="
                      (statusObj = getStatusColor(item.status))
                        ? statusObj.color
                        : '#EF4444'
                    "
                    class="status-alert px-3 py-1"
                    dense
                    text
                  >
                    {{ bookingStatus(item) }}
                  </v-alert>
                </v-list-item-subtitle>
                <v-list-item-subtitle class="table-body-light">
                  {{ converIsoToDate(item.bookingStartDate) }} •
                  {{ converIsoToTime(item.bookingStartDate) }} -
                  {{ converIsoToTime(item.bookingEndDate) }} •
                  {{ "£ " + parseInt(item.bookingTypeObj.fees, 0) / 100 }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12">
        <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
          <div slot="spinner">
            <v-row>
              <v-col v-for="n in 12" :key="n" cols="12">
                <v-skeleton-loader type="card-heading, list-item-two-line" />
              </v-col>
            </v-row>
          </div>
          <div slot="no-more" />
          <div slot="no-results" class="no-results">
            <v-card elevation="0">
              <v-card-title class="dialog-title-sm">
                <v-spacer />
                <strong>Sorry 😞</strong>, we couldn't find any results.
                <v-spacer />
              </v-card-title>
            </v-card>
          </div>
        </infinite-loading>
      </v-col>
    </v-row>
    <v-row v-else class="pa-6">
      <v-col cols="12">
        <span class="filter-design">From date</span>
        <date-field
          v-model="fromDate"
          placeholder="Select from date"
          @change="onDateChange()"
          hide-details
          solo
        />
      </v-col>
      <v-col cols="12">
        <span class="filter-design">To date</span>
        <date-field
          v-model="toDate"
          :min="fromDate"
          placeholder="Select to date"
          @change="onDateChange()"
          hide-details
          solo
        />
      </v-col>
      <v-col cols="12">
        <span class="filter-design">Appointment status</span>
        <select-field
          v-model="status"
          :items="statusList"
          @change="onStatusChange()"
          hide-details
          solo
        />
      </v-col>
      <v-row class="justify-space-between px-6">
        <v-btn
          text
          class="text-capitalize"
          @click="
            clearAllFields();
            applyFilters = false;
          "
        >
          Go Back
        </v-btn>
        <v-btn
          :disabled="clearFilterDisable"
          outlined
          color="#096DD8"
          class="text-capitalize"
          @click="applyFilters = false"
        >
          Apply filters
        </v-btn>
      </v-row>
    </v-row>
  </div>
</template>

<script>
import { VSelect, VDate } from "@/components/inputs";
import RejectBooking from "./components/RejectBooking";
import { BookingService } from "@/services";
import moment from "moment";
import InfiniteLoading from "vue-infinite-loading";
import _ from "lodash";
import {
  APPOINTMENT_REQUEST_SENT,
  APPOINTMENT_PENDING_FOR_APPROVAL,
  APPOINTMENT_APPROVED,
  APPOINTMENT_RESCHEDULED,
  RESCHEDULED_APPOINTMENT_APPROVED,
  REJECTED_BY_DOCTOR,
  REJECTED_BY_PATIENT,
  APPOINTMENT_COMPLETED,
  REJECTED_BY_SYSTEM
} from "@/constants";

export default {
  components: {
    SelectField: VSelect,
    DateField: VDate,
    RejectBooking,
    InfiniteLoading
    // BreadCrumb: () => import("@/components/BreadCrumb")
  },
  watch: {
    page() {
      this.init();
    }
  },
  data() {
    return {
      sortOptions: [
        { value: 0, text: "Sort by" },
        { value: 1, text: "Doctor Name" },
        { value: 2, text: "Status" },
        { value: 3, text: "Date" },
        { value: 4, text: "Price" }
      ],
      sortBy: 0,
      searchVal: "",
      sortByOption: 0,
      applyFilters: false,
      loading: false,
      fromDate: null,
      toDate: null,
      status: "",
      page: 1,
      pageCount: 0,
      infiniteId: +new Date(),
      itemsPerPage: 20,
      APPOINTMENT_PENDING_FOR_APPROVAL: APPOINTMENT_PENDING_FOR_APPROVAL,
      APPOINTMENT_APPROVED: APPOINTMENT_APPROVED,
      APPOINTMENT_RESCHEDULED: APPOINTMENT_RESCHEDULED,
      RESCHEDULED_APPOINTMENT_APPROVED: RESCHEDULED_APPOINTMENT_APPROVED,
      REJECTED_BY_DOCTOR: REJECTED_BY_DOCTOR,
      REJECTED_BY_PATIENT: REJECTED_BY_PATIENT,
      APPOINTMENT_COMPLETED: APPOINTMENT_COMPLETED,
      REJECTED_BY_SYSTEM: REJECTED_BY_SYSTEM,
      statusList: [
        {
          text: "All",
          value: "",
          color: ""
        },
        {
          text: APPOINTMENT_REQUEST_SENT,
          value: APPOINTMENT_PENDING_FOR_APPROVAL,
          color: "#F59E0B"
        },
        {
          text: APPOINTMENT_RESCHEDULED,
          value: APPOINTMENT_RESCHEDULED,
          color: "#F59E0B"
        },
        {
          text: APPOINTMENT_APPROVED,
          value: APPOINTMENT_APPROVED,
          color: "#56B884"
        },
        {
          text: RESCHEDULED_APPOINTMENT_APPROVED,
          value: RESCHEDULED_APPOINTMENT_APPROVED,
          color: "#56B884"
        },
        {
          text: APPOINTMENT_COMPLETED,
          value: APPOINTMENT_COMPLETED,
          color: "#56B884"
        },
        {
          text: REJECTED_BY_DOCTOR,
          value: REJECTED_BY_DOCTOR,
          color: "#EF4444"
        },
        {
          text: REJECTED_BY_PATIENT,
          value: REJECTED_BY_PATIENT,
          color: "#EF4444"
        },
        {
          text: REJECTED_BY_SYSTEM,
          value: REJECTED_BY_SYSTEM,
          color: "#EF4444"
        }
      ],
      headers: [
        // {
        //   text: "Clinic Name",
        //   value: "workplaceObj.name",
        //   class: "table-header-title"
        // },
        {
          text: "Doctor Name",
          value: "doctorObj.firstName",
          class: "table-header-title"
        },
        {
          text: "Date",
          value: "bookingDate",
          class: "table-header-title"
        },
        {
          text: "Time",
          value: "bookingStartDate",
          class: "table-header-title"
        },
        // {
        //   text: "End Time",
        //   value: "bookingEndDate",
        //   class: "table-header-title"
        // },
        {
          text: "Price",
          value: "bookingTypeObj.fees",
          class: "table-header-title"
        },
        { text: "Status", value: "status", class: "table-header-title" },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          class: "table-header-title",
          width: "100px"
        }
      ],
      bookings: [],
      bookingsMobileView: []
    };
  },
  computed: {
    clearFilterDisable() {
      return this.fromDate || this.toDate || this.status ? false : true;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    searchBooking() {
      this.page = 1;
      this.bookingsMobileView = [];
      this.infiniteId += 1;
    },
    async refresh() {
      this.page = 1;
      this.bookingsMobileView = [];
      this.infiniteId += 1;
      this.init();
    },
    bookingStatus(item) {
      if (item.status == APPOINTMENT_PENDING_FOR_APPROVAL) {
        return APPOINTMENT_REQUEST_SENT;
      } else {
        return item.status;
      }
    },
    // For infnite loading
    async infiniteHandler($state) {
      const params = {
        limit: parseInt(this.itemsPerPage),
        skip:
          parseInt(this.page) * parseInt(this.itemsPerPage) -
          parseInt(this.itemsPerPage)
      };
      if (this.searchVal) {
        params.search = this.searchVal;
      }
      if (this.status) {
        params.status = this.status;
      }
      if (this.fromDate) {
        params["date[gt]"] = moment(this.fromDate)
          .startOf("day")
          .toISOString();
      }
      if (this.toDate) {
        params["date[lt]"] = moment(this.toDate)
          .endOf("day")
          .toISOString();
      }
      const allBookings = await BookingService.getBooking(params);
      if (allBookings && allBookings.data && allBookings.data.data.length > 0) {
        this.page += 1;
        this.bookingsMobileView.push(...allBookings.data.data);
        if (allBookings.data.option[0].count > this.bookingsMobileView.length) {
          $state.loaded();
        } else {
          $state.loaded();
          $state.complete();
        }
      } else {
        $state.complete();
      }
    },
    async init() {
      const params = {
        limit: 50,
        skip: 0
      };
      this.bookings = [];
      if (this.status) {
        params.status = this.status;
      }
      if (this.searchVal) {
        params.search = this.searchVal;
      }
      if (this.fromDate) {
        params["date[gt]"] = moment(this.fromDate)
          .startOf("day")
          .toISOString();
      }
      if (this.toDate) {
        params["date[lt]"] = moment(this.toDate)
          .endOf("day")
          .toISOString();
      }
      this.loading = true;
      const list = await BookingService.getBooking(params);
      this.loading = false;
      if (list.data.data.length > 0) {
        this.bookings = list.data.data;
        this.pageCount = Math.ceil(
          list.data.option[0].count / this.itemsPerPage
        );
      } else {
        this.bookings = [];
        this.pageCount = 1;
        if (this.page !== 1) {
          this.page--;
        }
      }
    },
    onStatusChange() {
      this.page = 1;
      this.bookingsMobileView = [];
      this.infiniteId += 1;
      this.init();
    },
    onDateChange() {
      this.page = 1;
      this.bookingsMobileView = [];
      this.infiniteId += 1;
      this.init();
    },
    editBooking(item) {
      this.$router.push(
        `/book-appointment/${item.doctorId}/${item.bookingTypeObj.workplaceId}/${item._id}`
      );
    },
    converIsoToTime(isoDate) {
      return moment(isoDate).format("hh: mm a");
    },
    converIsoToDate(isoDate) {
      if (isoDate) {
        return moment(isoDate).format("DD.MM.YYYY");
      }
      return "";
    },
    formatAmount(price) {
      return parseInt(price / 100);
    },
    clearAllFields() {
      this.fromDate = null;
      this.toDate = null;
      this.status = "";
      this.page = 1;
      this.bookingsMobileView = [];
      this.infiniteId += 1;
      this.init();
    },
    getStatusColor(currentStatus) {
      return this.statusList.find(function(status) {
        if (_.startCase(currentStatus) === status.value) {
          return status;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.elevation-1 {
  box-shadow: none !important;
  border: 1px solid #e0e0e0;
}
.filter-text {
  font-family: "Now Alt";
  font-weight: 500;
  font-size: 14px;
  color: #2f4c67;
}
.date-text {
  font-family: "Now Alt";
  font-weight: 400;
  font-size: 12px;
  color: #677c95;
  letter-spacing: 0.005em;
}
.card-title {
  color: #344452;
  text-transform: capitalize;
  font-family: "Now Alt", sans-serif;
  font-size: 14px;
  font-weight: 500;
}
.text-transform {
  text-transform: capitalize !important;
  font-size: 16px;
}
.filter-design {
  font-weight: 500;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0.75px;
  color: #0c1f36;
}
.table-body-text {
  font-family: "Now Alt";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 160%;
  letter-spacing: 0.005em;
  color: #27445b;
}
.table-body-text-light {
  font-family: "Now Alt";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 160%;
  letter-spacing: 0.005em;
  color: #677c95;
}
.dialog-text {
  font-family: "Now Alt";
  font-style: normal;
  font-size: 18px;
  line-height: 130%;
  color: #313131;
  letter-spacing: 0.05em;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th {
  font-size: 14px !important;
  height: 48px;
  font-weight: 500;
  color: #677c95 !important;
}
.table-footer-text {
  font-family: "Now Alt";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #27445b;
}
.status-alert {
  width: fit-content !important;
  font-size: 12px;
  margin: auto 0;
}
.border-top-thin {
  border-top: thin solid rgba(0, 0, 0, 0.12);
}
.schedule-text {
  text-transform: none;
  font-family: "Now Alt";
  font-weight: 400;
  font-size: 14px;
}
::v-deep .v-data-footer__select .v-select {
  margin: 13px 0 13px 34px !important;
  font-size: 12px;
}
::v-deep .v-data-footer__select {
  font-size: 12px;
}
::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  box-shadow: none !important;
  border: 1px solid #e0e0e0 !important;
  margin: 0px;
}
</style>
